import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CallDurationService {
  readonly formatted = signal('00:00');

  private timer: ReturnType<typeof setInterval> | null = null;
  private seconds = 0;

  start(): void {
    this.stop();
    this.seconds = 0;
    this.updateDisplay();
    this.timer = setInterval(() => {
      this.seconds += 1;
      this.updateDisplay();
    }, 1000);
  }

  stop(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.seconds = 0;
    this.formatted.set('00:00');
  }

  private updateDisplay(): void {
    const mins = Math.floor(this.seconds / 60);
    const secs = this.seconds % 60;
    this.formatted.set(`${this.pad(mins)}:${this.pad(secs)}`);
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
